<template>
    <div class="fund-list">
        <el-row v-if="fundInfo.length <= 0 && hasLoad" class="no-funds">
            <el-col :span="12" :offset="8">
                <span class="no-funds-img" />
                <div class="no-funds-box">
                    <p>{{ noFundMsg }}</p>
                </div>
            </el-col>
        </el-row>
        <el-table
            v-else-if="hasLoad"
            :data="fundAll"
            style="width: 100%"
            class="tab-list-tit"
            :header-cell-style="{ background: '#F9F9F9' }"
        >
            <el-table-column label="产品名称" width="280" class-name="fund-offset">
                <template slot-scope="scope">
                    <div class="fund-name" v-on:click.stop="gotoDetail(scope.row)">
                        {{ scope.row.fundshortname || scope.row.fundname }}
                    </div>
                    <div style="color: #999999">
                        {{ $util.fmtDate(scope.row.navdate) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="基金代码" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.fundcode }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="单位净值" align="center">
                <template slot-scope="scope">
                    <div>
                        <span
                            v-if="lock"
                            class="grey"
                            v-on:click.stop="showBuyModal(scope.row.fundcode, 'lock')"
                        >
                            {{ lockText }}
                        </span>
                        <span v-else>{{ $util.fmtNum(scope.row.nav, 4) }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="累计净值" align="center">
                <template slot-scope="scope">
                    <div>
                        <span
                            v-if="lock"
                            class="grey"
                            v-on:click.stop="showBuyModal(scope.row.fundcode, 'lock')"
                        >
                            {{ lockText }}
                        </span>
                        <span v-else>{{ $util.fmtNum(scope.row.totalnav, 4) }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="日涨幅" align="center">
                <template slot-scope="scope">
                    <span
                        v-if="lock"
                        class="grey"
                        v-on:click.stop="showBuyModal(scope.row.fundcode, 'lock')"
                    >
                        {{ lockText }}
                    </span>
                    <span v-else :class="$util.colorClass(formatterRate(scope.row.dayfloatprofit))">
                        {{ formatterRate(scope.row.dayfloatprofit) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="近半年" align="center">
                <template slot-scope="scope">
                    <span
                        v-if="lock"
                        class="grey"
                        v-on:click.stop="showBuyModal(scope.row.fundcode, 'lock')"
                    >
                        {{ lockText }}
                    </span>
                    <span v-else :class="$util.colorClass(formatterRate(scope.row.month6ud))">
                        {{ formatterRate(scope.row.month6ud) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="近一年" align="center">
                <template slot-scope="scope">
                    <span
                        v-if="lock"
                        class="grey"
                        v-on:click.stop="showBuyModal(scope.row.fundcode, 'lock')"
                    >
                        {{ lockText }}
                    </span>
                    <span v-else :class="$util.colorClass(formatterRate(scope.row.year1ud))">
                        {{ formatterRate(scope.row.year1ud) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="今年以来" align="center">
                <template slot-scope="scope">
                    <span
                        v-if="lock"
                        class="grey"
                        v-on:click.stop="showBuyModal(scope.row.fundcode, 'lock')"
                    >
                        {{ lockText }}
                    </span>
                    <span v-else :class="$util.colorClass(formatterRate(scope.row.thisyear1ud))">
                        {{ formatterRate(scope.row.thisyear1ud) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="成立以来" align="center" width="100">
                <template slot-scope="scope">
                    <span
                        v-if="lock"
                        class="grey"
                        v-on:click.stop="showBuyModal(scope.row.fundcode, 'lock')"
                    >
                        {{ lockText }}
                    </span>
                    <span v-else :class="$util.colorClass(formatterRate(scope.row.allud))">
                        {{ formatterRate(scope.row.allud) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="风险等级" align="center">
                <template slot-scope="scope">
                    <div>{{ $cache.getDict("110143", scope.row.risklevel) }}</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="110">
                <template slot-scope="scope">
                    <div class="btns">
                        <el-tooltip
                            v-if="scope.row.isBuy"
                            class="item"
                            effect="info"
                            :content="scope.row.isBuy + '，不能申购'"
                            placement="top"
                        >
                            <el-button disabled type="text" size="small">申购</el-button>
                        </el-tooltip>
                        <el-button
                            v-else
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="callbackFn('20,22', scope.row)"
                        >
                            {{ scope.row.status == "1" ? "认购" : "申购" }}
                        </el-button>
                        <template v-if="!$util.belongHx()">
                            <div class="line"></div>
                            <el-tooltip
                                v-if="scope.row.isCurrency"
                                class="item"
                                effect="info"
                                :content="scope.row.isCurrency + '，不能定投'"
                                placement="top"
                            >
                                <el-button disabled type="text" size="small">定投</el-button>
                            </el-tooltip>
                            <el-button
                                v-else
                                type="text"
                                plain
                                size="small"
                                v-on:click.stop="callbackFn('59', scope.row)"
                            >
                                定投
                            </el-button>
                        </template>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="allPage > 0" class="page-box">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="dataReset"
            />
        </el-row>
        <qr-code
            :fundcode="selectFundCode"
            :is-public="isPublic"
            :dialog-visible="buyDialogVisible"
            :tip-info="declarationInfo"
            v-on:dialog-close="buyDialogVisible = false"
        ></qr-code>
        <declaration-dialog
            :visible="declaraVisible"
            v-on:close="declaraVisible = false"
            v-on:refresh-list="update"
        ></declaration-dialog>
    </div>
</template>

<script>
import qrCode from "@/components/fund/qrCodeGuide";
import declarationDialog from "@/components/form/declarationDialog.vue";
import cache from "@/assets/js/cache";

export default {
    name: "FundList",
    components: {
        qrCode,
        declarationDialog
    },
    props: {
        fundInfo: {
            type: Array,
            default: () => {
                return [];
            },
            required: true
        },
        allPage: {
            type: String,
            default: ""
        },
        noFundMsg: {
            type: String,
            default: "基金公司没有添加基金产品，请联系基金公司添加！ "
        },
        isCollection: {
            type: Boolean,
            default: false
        },
        hasLoad: {
            type: Boolean,
            default: false
        },
        isPublic: {
            type: Boolean,
            default: true
        },
        lock: {
            // 是否声明可见
            type: Boolean,
            default: false
        },
        userinfo: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            url: "", // 当前页面路由命名
            fundAll: [],
            curPage: 1,
            buyDialogVisible: false, // 是否显示购买弹窗
            declaraVisible: false, // 投资者声明弹窗
            selectFundCode: "", // 所选基金代码
            lockText: "声明可见",
            declarationInfo: {
                tip: "您可选择以下任一方法至移动端完成基金购买",
                method1: '<span class="red">微信扫码完成基金购买</span>',
                method2: '<span class="red">使用理财客APP</span> ，扫码完成基金购买'
            }
        };
    },
    computed: {},
    watch: {
        fundInfo() {
            this.getNewFund();
        },
        allPage() {
            this.curPage = 1;
        }
    },
    mounted() {
        this.conf = this.$util.getConfig().const;
        this.url = this.$route.name;
        // if (this.$util.belongHx() && !this.isPublic && !this.$cache.getBinded()) {
        //     // todo 本期只做未开户的验证
        //     const userInfo = this.$cache.getUser();
        //     if (userInfo.disclaimersignflag != "1") {
        //         this.declaraVisible = true;
        //     }
        // }
    },
    methods: {
        // 跳转到基金详情
        gotoDetail(val) {
            this.$util.toFundDetail(val.fundcode, this.isPublic);
        },
        showBuyModal(fundcode, type) {
            this.selectFundCode = fundcode;
            switch (type) {
                case "buy":
                    if (this.userinfo.accreditedinvestor === "0") {
                        this.declarationInfo = {
                            tip: "请到微信或者APP进行合格投资者认证及下单购买",
                            method1:
                                '<span class="red">微信扫码</span>,进行合格投资者认证及下单购买',
                            method2:
                                '<span class="red">使用理财客APP扫码</span> ，进行合格投资者认证及下单购买'
                        };
                    } else {
                        this.declarationInfo = {
                            tip: "您可选择以下任一方法至移动端完成基金购买",
                            method1: '<span class="red">微信扫码完成基金购买</span>',
                            method2: '<span class="red">使用理财客APP</span> ，扫码完成基金购买'
                        };
                    }
                    break;
                case "lock":
                    this.declarationInfo = {
                        tip: "请到微信或者APP进行合格投资者声明,声明后可查看",
                        method1: '<span class="red">微信扫码</span>,进行合格投资者声明',
                        method2: '<span class="red">使用理财客APP扫码</span> ，进行合格投资者声明'
                    };
            }
            this.buyDialogVisible = true;
        },
        callbackFn(way, fund) {
            if (this.$util.belongHx() && !cache.getBinded()) {
                this.$belongToDialog();
                return;
            }
            if (this.$util.belongHx()) {
                // 和讯弹出二维码引导
                this.showBuyModal(fund.fundcode, "buy");
                return;
            }
            let moduleId = "";
            if (way == "59") {
                moduleId = way;
            } else {
                if (fund.status == "1") {
                    moduleId = "20";
                } else {
                    moduleId = "22";
                }
            }
            // 申购 22 认购 20
            this.$util.checkGtOcrModule(moduleId, "0", (res) => {
                this.$emit("fund-continue", way, fund);
            });
        },
        getNewFund() {
            let _arr = [];
            this.fundInfo.forEach((fund, index) => {
                const _x = Object.assign({}, fund);
                _x.index = index;
                _x.isBuy = this.$util.checkBuy(_x.status);
                _x.isCurrency = this.$util.checkGeneral(_x);
                _arr.push(_x);
            });
            this.fundAll = _arr;
        },
        dataReset(val) {
            this.$emit("new-fund", val);
        },
        // 格式化涨跌幅数据
        formatterRate(rate) {
            if (!rate) {
                return "--";
            }
            if (!this.isPublic) {
                // 私募数据要乘以100
                rate = rate * 100;
            }
            const prefix = Number(rate) > 0 ? "+" : "";
            return prefix + this.$util.fmtNum(rate) + "%";
        },
        // // 列表中"认证可见"是否翻转展示实际数据，已登录+已声明+已测评 。即完成投资者声明+完成测评 才能看到认证可见的部分
        // authentication() {
        //     if (
        //         this.$util.belongHx() &&
        //         !this.isPublic &&
        //         (this.userInfo.riskexpired !== "0" || this.userInfo.disclaimersignflag !== "1")
        //     ) {
        //         this.lock = true;
        //     }
        //     this.lock = false;
        // },
        // 刷新界面
        update() {
            // 重新赋值，刷新界面
            // this.userInfo = this.$cache.getUser();
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";

.el-table td.el-table__cell div {
    color: #333333;
    font-weight: 400;
}

.el-table td.el-table__cell span {
    color: #333333;
    font-weight: 400;

    &.add {
        color: $risk5;
    }

    &.reduce {
        color: $risk1;
    }
}
.el-table td.el-table__cell .grey {
    color: #cccccc;
}

.fund-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}

.btns {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 11px;
}

.line {
    background: #e8e8e8;
    width: 1px;
    height: 12px;
}

// .el-pager li {
//     background: transparent;
// }
// .el-pagination .btn-prev, .el-pagination .btn-next {
//     background-color: transparent;
// }
// .el-pagination button:disabled {
//     background-color: transparent;
// }
.el-pagination {
    margin-bottom: 0;
}

.el-button.is-plain:hover,
.el-button.is-plain:focus,
.el-button.is-disabled.is-plain {
    background-color: transparent;
    border-color: transparent;
}

.el-button--text {
    font-size: 14px;
    font-weight: 400;
    color: #e60012;
}

.el-button--text.is-disabled {
    color: #cccccc;
}

.el-table {
    border: 1px solid #f1f1f1;
}
.el-table--fit {
    margin-bottom: 15px;
}
</style>
